import { FC, MouseEventHandler } from "react";

// Components
import { OptionItem, OptionMenu } from "~/components/Common";

// Styles
import { StyledDeleteButton } from "./WalletOptions.styled";

interface WalletOptionsProps {
  open: boolean;
  anchorEl: null | HTMLElement;
  id: string;
  onClose: MouseEventHandler;
  onDelete: MouseEventHandler;
  onAddMember: MouseEventHandler;
}

const WalletOptions: FC<WalletOptionsProps> = ({
  onDelete,
  onAddMember,
  ...props
}) => {
  return (
    <OptionMenu {...props}>
      <OptionItem onClick={onAddMember}>Add member</OptionItem>
      <OptionItem onClick={() => {}}>Export Wallet</OptionItem>
      <OptionItem onClick={() => {}}>Clone Wallet</OptionItem>
      <StyledDeleteButton onClick={onDelete}>Delete Wallet</StyledDeleteButton>
    </OptionMenu>
  );
};

export default WalletOptions;
